module.exports = __webpack_public_path__ + "img/img33.5def6341.svg";